import { COMPONENTS } from '../../../components/components.registry';
import { EmptySearchConfig } from '../../../models';

export const DEFAULT_EMPTY_CONFIG: EmptySearchConfig = {
  components: {
    emptySearch: COMPONENTS.PURE.EmptySearch
  }
};
